import React from 'react';
import {
  CmsComponentData,
  CmsComponentGrid,
  ContentComponentLibraryProvider,
} from '@johnlewispartnership/wtr-content-component-library';
import type { Config } from '@johnlewispartnership/wtr-content-component-library/dist/component-library/config/types';

import cmsComponentMap from './componentMap';

// For now, we always import the global grid styles
import './styles/grid.scss';

type EntrypointProps = {
  componentData: CmsComponentData[];
  componentLibraryConfig: Omit<Config, 'componentMap'>;
};

// NOTE: This is used on both the server & client.
const Entrypoint = ({ componentData, componentLibraryConfig }: EntrypointProps) => {
  const config: Config = {
    componentMap: cmsComponentMap,
    ...componentLibraryConfig,
  };

  return (
    <ContentComponentLibraryProvider config={config}>
      <CmsComponentGrid childComponents={componentData} />
    </ContentComponentLibraryProvider>
  );
};
export default Entrypoint;
